import * as store_helpers from './store_helpers';

export const AUDIT_STATE_ASSIGN = 'AUDIT_STATE_ASSIGN';
export const AUDIT_STATE_SET_AUDIT = 'AUDIT_STATE_SET_AUDIT';
export const AUDIT_STATE_SET_AUDITS = 'AUDIT_STATE_SET_AUDITS';

let default_state = {
    all: [],
    by_id: {},
};

export default function userReducer(state = default_state, action) {
    switch (action.type) {
        case AUDIT_STATE_ASSIGN: {
            return Object.assign({}, state, action.payload);
        }
        case AUDIT_STATE_SET_AUDIT: {
            return store_helpers.SetItem(action.payload, state);
        }
        case AUDIT_STATE_SET_AUDITS: {
            return store_helpers.SetItems(action.payload, state);
        }
        default: {
            return state;
        }
    }
}
